import React, { useEffect, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { Like, onestar, tesla } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { VehicleType } from "../../types";
import Loading from "../loading/Loading";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { useCalculateDistance } from "../../hooks/useCalculatedDistance";
import { distanceToMiles } from "../../utils/DistanceToMiles";
import {
  capitalizeWords,
  splitStringByComma,
} from "../../utils/splitStringByComma";
import { ClipLoader, FadeLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { getTruewayDistance } from "../../api/truewayDistance";
import useDistanceCalculator from "../../hooks/useDistanceCalculator";
import { loader } from "../..";

type VehicleCardProps = {
  vehicle: VehicleType;
  index: number;
  setSelectedCarID: React.Dispatch<React.SetStateAction<string>>;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
};

const VehicleCard: React.FC<VehicleCardProps> = ({
  vehicle,
  index,
  setSelectedCarID,
  setShowModal,
  showModal,
}) => {
  const navigate = useNavigate();

  // console.log("pickupLocation", pickupLocation);

  const [loading, setLoading] = useState<boolean>(false);
  const [images, setImages] = useState<string[]>([]);
  const [milesAway, setMilesAway] = useState<number | string | undefined>(
    undefined
  );
  const [milesAwayLoading, setMilesAwayLoading] = useState<boolean>(false);

  // console.log(vehicle?.parkedLocation);
  // const distance = useCalculateDistance(
  //   { lat: 40.7128, lng: -74.006 },
  //   // {
  //   //   lat: pickupLocation.lat ?? 40.45567177153205,
  //   //   lng: pickupLocation.lng ?? -74.4174187257886,
  //   // },
  //   {
  //     lat: vehicle?.parkedLocation.latitude,
  //     lng: vehicle?.parkedLocation.longitude,
  //   }
  // );
  // // if (
  // //   vehicle?.parkedLocation.latitude === 40.45567177153205 &&
  // //   vehicle?.parkedLocation.longitude === -74.4174187257886
  // // ) {
  // //   console.log("distance", distance);
  // //   console.log("vehicle", vehicle);
  // // }

  const { getDistanceFromUser, getDistanceFromUserInVicenty } =
    useDistanceCalculator();

  // const distance = getDistanceFromUser(
  //   vehicle?.parkedLocation.latitude,
  //   vehicle?.parkedLocation.longitude
  // );

  useEffect(() => {
    if (!images.length) {
      setLoading(true);

      // const distance = getDistanceFromUser(
      //   vehicle?.parkedLocation.latitude,
      //   vehicle?.parkedLocation.longitude
      // );

      // console.log("distance", distance);

      // // if (distance) {
      // //   setMilesAway(Number(Number(distance).toFixed(2)));
      // // }

      // if (distance?.distance?.value !== undefined && !milesAway) {
      //   // console.log(
      //   //   distance?.distance?.value,
      //   //   distance?.distance?.value! * 0.000621371
      //   // );
      //   // console.log(distance?.distance?.value);
      //   setMilesAway(distanceToMiles(distance?.distance?.value));
      //   // console.log(milesAway);

      // }
      const imgArr = vehicle?.carImages?.filter((image) => image.imageUrl);
      const imgMap = imgArr.map((image) => image.imageUrl);
      const imgArrs = new Set(imgMap);

      setImages(Array.from(imgArrs));

      setLoading(false);
    }
  }, [vehicle?.carImages]);

  async function getDM(
    o: {
      lat: number;
      lng: number;
    },
    l: {
      lat: number;
      lng: number;
    }
  ) {
    await loader.importLibrary("routes").then((routes) => {
      const distanceMatrix = new routes.DistanceMatrixService();

      distanceMatrix.getDistanceMatrix(
        {
          origins: [o],
          destinations: [l],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.IMPERIAL,
        },
        (res: any, status: any) => {
          if (!milesAway) {
            // console.log(res, status);

            let gdf = JSON.parse(window.localStorage.getItem("gdf")!) || [];
            const newElement = {
              l,
              o,
              d: res?.rows[0]?.elements[0]?.distance?.text ?? "? miles",
            };

            // Check if the new element already exists in gdf
            const isElementUnique = !gdf.some(
              (element: any) =>
                element.l === newElement.l &&
                element.o === newElement.o &&
                element.d === newElement.d
            );

            if (isElementUnique) {
              // If the element is unique, add it to the array
              gdf.push(newElement);
            }

            // console.log("allGdf", gdf.length);

            // Convert the array to a Set to remove duplicates
            const uniqueGdf = new Set(gdf);

            // console.log("uniqueGdf", Array.from(uniqueGdf).length);

            // Convert the Set back to an array and store it in localStorage
            window.localStorage.setItem(
              "gdf",
              JSON.stringify(Array.from(uniqueGdf))
            );

            setMilesAway(
              res?.rows[0]?.elements[0]?.distance?.text ?? "? miles"
            );
          }
        }
      );
    });
  }

  const gdf: any[] = JSON.parse(window.localStorage.getItem("gdf")!);

  const l = {
    lat: vehicle?.parkedLocation?.latitude ?? 0,
    lng: vehicle?.parkedLocation?.longitude ?? 0,
  };

  const o = {
    // lat: vehicle?.parkedLocation.latitude,
    lat: 40.7128,
    // lng: vehicle?.parkedLocation.longitude,
    lng: -74.006,
  };

  // console.log("gdf", gdf[0]?.o, o, gdf[0]?.o === o);

  const loc = gdf?.find(
    (obj) =>
      obj?.l?.lat === l.lat &&
      obj?.l?.lng === l.lng &&
      obj?.o?.lat === o.lat &&
      obj?.o?.lng === o.lng
  );

  // if (loc && !milesAway) {
  //   // console.log("loc", loc);
  //   setMilesAway(loc?.d);
  // } else if (!loc && !milesAway) {
  //   // getDM(o, l);
  // }

  useEffect(() => {
    if (loc && !milesAway) {
      setMilesAway(loc?.d);
      return;
    } else if (!loc && !milesAway) {
      getDM(o, l);
      return;
    } else {
      // setMilesAway("? mi");
      return;
    }
  }, [milesAway, loc]);

  // TODO: Complete distance fetch and convert to miles
  // useEffect(() => {
  //   getTruewayDistance(
  //     "40.7128,-74.006,",
  //     `${vehicle?.parkedLocation.latitude},${vehicle?.parkedLocation.longitude}`
  //   ).then((res) => {
  //     console.log(res, "trueway");
  //   });
  // }, []);

  useEffect(() => {
    if (milesAway) {
      setMilesAwayLoading(false);
    } else {
      setMilesAwayLoading(true);
    }
  }, [milesAway]);

  if (loading) return <Loading loading={loading} />;

  return (
    <div
      className="bg-white flex flex-col gap-3 pb-4 w-[47%] md:w-[40%] xl:w-[30%] flex-shrink-0"
      key={index}
      onClick={() => {
        setSelectedCarID(vehicle.id);
        setShowModal(!showModal);
        // navigate(`/vehicles/${vehicle.id}`);
      }}
    >
      <div className="relative w-full h-[150px] p-1 md:p-4  ">
        {images.length > 0 && (
          <img
            src={ipfsGatewayImage(images[0])}
            alt=""
            className="w-full h-full object-cover border rounded-md"
          />
        )}
        {/* <img src={Like} alt="" className="absolute top-0 right-0 p-4" /> */}
      </div>
      <div className="flex justify-between px-1 md:px-4 lg:px-6">
        <div className="flex flex-col gap-2 w-2/3 md:w-1/2">
          <h3 className=" font-Jakarta text-[12px] lg:text-[19px] leading-6 font-bold text-[#1a202c] ">
            {capitalizeWords(vehicle?.make)} <br />{" "}
            {capitalizeWords(vehicle?.model)}
          </h3>
          <p className="flex gap-1 items-center  text-[#90acbf] font-Poppins text-[8px] lg:text-[10px] font-normal ">
            <img src={onestar} alt="" />
            {vehicle.carRatings.length
              ? (
                  vehicle.carRatings.reduce(
                    (acc, curr) => acc + curr.meanRating,
                    0
                  ) / vehicle.carRatings.length
                ).toFixed(1)
              : "0.0"}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-[#000] font-Jakarta text-[11px] lg:text-lg font-bold text-right">
            ${vehicle?.pricePerHour}/{" "}
            <span className="font-Jakarta text-[#90a3bf] text-[7px] lg:text-[13px] font-bold">
              day
            </span>
          </h3>
          <div className="flex gap-2 text-[#90a3bf] font-Jakarta font-medium text-[8px] lg:text-[10px] border border-[#90a3bf] rounded-3xl p-1 items-center">
            <CiLocationOn size={15} color="darkGreen" />
            {!milesAwayLoading ? (
              <span>{milesAway} away</span>
            ) : (
              <div className="h-[10px] flex flex-row gap-2 items-center ">
                <ClipLoader
                  color={"#90a3bf"}
                  loading={milesAwayLoading}
                  size={15}
                  speedMultiplier={1}
                />
                miles away
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mx-auto bg-darkGreen flex items-center justify-center mt-auto w-5/6 border rounded-lg cursor-pointer text-white p-3 ">
        <button type="button">View Details</button>
      </div>
    </div>
  );
};

export default VehicleCard;
